module.exports = __webpack_public_path__ + "img/removablemedia.c6fd20af.svg";